<div class="tab" [hidden]="!muestraModulos">
    <button class="tablinks" (click)="cambiaTab(1)" [hidden]="!muestraTabPanelControl"
        [className]="indiceTab == 1 ? 'active' : 'tablinks'">Panel de control</button>
    <!-- <button class="tablinks" (click)="cambiaTab(2)" [hidden]="!muestraTabAfiliaciones"
        [className]="indiceTab == 2 ? 'active' : 'tablinks'">Afiliaciones</button>
    <button class="tablinks" (click)="cambiaTab(3)" [hidden]="!muestraTabPrestacional"
        [className]="indiceTab == 3 ? 'active' : 'tablinks'">Prestacional</button> -->
    <button class="tablinks" [hidden]="true" (click)="cambiaTab(2)" 
        [className]="indiceTab == 4 ? 'active' : 'tablinks'">Atención</button>
    <button class="tablinks" [hidden]="true" (click)="cambiaTab(3)"
        [className]="indiceTab == 3 ? 'active' : 'tablinks'">Mensajes!</button>
</div>
<div id="Panel" [className]="indiceTab == 1 ? 'active' : 'tabcontent'" style="margin-top:3px;">
    <div>
        <table>
            <tr>
                <td style="width: 25%;"></td>
                <td style="padding-top: 20px; width: 20%;">
                    <button mat-raised-button class="btn-agregar" (click)="modificarEnvio('00000000-0000-0000-0000-000000000000')"
                        style="margin-top: 1vh; width: auto; padding-left: 50px; padding-right: 50px;">
                        Agregar envio de mails
                    </button>
                </td>
                <td style="width: 10%;"></td>
                <td style="padding-top: 20px; width: 20%;">
                    <button mat-raised-button class="btn-agregar" (click)="modificarNotificacion('00000000-0000-0000-0000-000000000000')"
                        style="margin-top: 1vh; width: auto; padding-left: 50px; padding-right: 50px;">
                        Agregar notificación
                    </button>
                </td>
                <td style="width: 25%;"></td>
            </tr>
        </table>
        <div style="margin-left: 5%; margin-right: 5%; padding: 10px;
            text-align: center;" [hidden]="escondeFraseNoHay">
            <h4 style="color: #a31611;"><b>Todavía no se agregó ningún envio</b></h4>
        </div>
        <div style="margin-left: 5%; margin-right: 5%; padding-left: 20px; padding-right: 20px;" 
            [hidden]="!escondeFraseNoHay">
            <div fxLayout fxLayoutAlign="center center">
                <mat-form-field fxFlex="40%">
                <input matInput type="text" (keyup)="buscar($event.target.value)" placeholder="Búsqueda"
                    autocomplete="off">
                </mat-form-field>
            </div>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%;">
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef style="width:10%;"> Acciones </th>
                    <td mat-cell *matCellDef="let element">
                        <i class="fas fa-pencil-alt" style="width: 10px; margin-right:5%;
                            font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                            margin-top: 0px; margin-right: 3vw;"
                            (click)="modificarEnvio(element.idEnvio)"
                        ></i>
                    </td>
                </ng-container>
                <ng-container matColumnDef="fechaCrea">
                    <th mat-header-cell *matHeaderCellDef style="width:20%;"> Fecha</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.fechaCrea}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="consorcio">
                    <th mat-header-cell *matHeaderCellDef style="width:50%;"> Consorcio</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.consorcio}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="estado">
                    <th mat-header-cell *matHeaderCellDef style="width:30%;"> Estado</th>
                    <td mat-cell *matCellDef="let element">
                    {{element.estado}}
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>">
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator #paginador [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>
<div id="Atencion" [className]="indiceTab == 2 ? 'active' : 'tabcontent'" style="margin-bottom: 50px;">
    
</div>